import { getFundingProgramProperties } from "@outschool/funding-programs-shared";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";
import { useExperiment } from "@outschool/ui-experiments";
import { useCallback } from "react";

type UseConcierge = {
  canAccessConcierge: boolean;
};

export default function useConcierge(): UseConcierge {
  const { currentUser, isLoggedIn } = useSession();

  const esaState = useFundingProgramAbbr();
  const fundingProgramProperties = getFundingProgramProperties(esaState);
  const isClassWalletProgram = fundingProgramProperties?.isClassWallet;

  const canAccessConcierge =
    isLoggedIn &&
    (currentUser?.hasSubscription ||
      currentUser?.hasEsaMembership ||
      isClassWalletProgram);

  return {
    canAccessConcierge: !!canAccessConcierge,
  };
}

export function useIntercomConciergeExperiment() {
  const { currentUserHasLoaded, isLoggedIn } = useSession();

  const { variant, trigger } = useExperiment({
    currentUserHasLoaded,
    experimentName: "IntercomConcierge",
  });

  const triggerExperiment = useCallback(() => {
    if (isLoggedIn) {
      trigger();
    }
  }, [isLoggedIn, trigger]);

  return {
    variant,
    isIntercomConciergeTreatment: isLoggedIn && variant === "treatment",
    triggerExperiment,
  };
}
